'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$() {
}
export { $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$ as $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$ };
$p = $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$PurchaseOrder$() {
}
export { $h_Lapp_data_AppDocumentDataForm$PurchaseOrder$ as $h_Lapp_data_AppDocumentDataForm$PurchaseOrder$ };
$h_Lapp_data_AppDocumentDataForm$PurchaseOrder$.prototype = $p;
$p.n = (function() {
  return "PurchaseOrder";
});
$p.bKl = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$PurchaseOrder(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKl(p);
});
var $d_Lapp_data_AppDocumentDataForm$PurchaseOrder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$PurchaseOrder$, "app.data.AppDocumentDataForm$PurchaseOrder$", ({
  B8: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$PurchaseOrder$ as $d_Lapp_data_AppDocumentDataForm$PurchaseOrder$ };
var $n_Lapp_data_AppDocumentDataForm$PurchaseOrder$;
function $m_Lapp_data_AppDocumentDataForm$PurchaseOrder$() {
  if ((!$n_Lapp_data_AppDocumentDataForm$PurchaseOrder$)) {
    $n_Lapp_data_AppDocumentDataForm$PurchaseOrder$ = new $c_Lapp_data_AppDocumentDataForm$PurchaseOrder$();
  }
  return $n_Lapp_data_AppDocumentDataForm$PurchaseOrder$;
}
export { $m_Lapp_data_AppDocumentDataForm$PurchaseOrder$ as $m_Lapp_data_AppDocumentDataForm$PurchaseOrder$ };
//# sourceMappingURL=app.data.-App-Document-Data-Form$-Purchase-Order$.js.map
